<template>
  <div class="row">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{displayName}}</h5>
    </div>
    <div class="col-md-6">
      <card-list-info header="Issue Detail" :items="issueDetail"></card-list-info>
      <card-list-info header="Company Information" :items="companyInfo"></card-list-info>
    </div>
    <div class="col-md-6">
      <card-list-info header="Company Information" :items="driverInfo"></card-list-info>
      <card-list-info header="Vehicle Information" :items="vehicleInfo"></card-list-info>
    </div>
  </div>
</template>
<script>
import dateMixin from '@/mixins/date';
import CardListInfo from '@/components/CardListInfo';
import Multiselect from 'vue-multiselect';

export default {
  mixins: [dateMixin],
  components: {
    CardListInfo,
    Multiselect,
  },
  data() {
    return {
      selectedCompany: null,
    };
  },
  created() {
    const { vehicleId } = this.$route.params;
    this.$store.commit('issues/SET_DETAIL_ID', vehicleId);
    this.$store.dispatch('issues/LOAD_DETAIL_DATA');
  },
  computed: {
    displayName() {
      return this.detailedInfo.reg_no;
    },
    detailedInfo() {
      return this.$store.getters['issues/get_detail_data'];
    },
    issueDetail() {
      const info = this.detailedInfo;

      const infoList = [
        { key: 'id', label: 'ID Number', value: info.id },
        { key: 'title', label: 'Title', value: info.title },
        { key: 'status', label: 'Status', value: info.status },
        { key: 'issue_type', label: 'Issue Type', value: !info.issue_type ? '-' : info.issue_type },
        { key: 'metadata', label: 'Metadata', value: !info.metadata ? '-' : info.metadata },
        { key: 'desc', label: 'Description', value: info.description },
        {
          key: 'created_at',
          label: 'Created at',
          value: this.formatDateDistance(info.created_at),
          title: this.formatDateTime(info.created_at),
        },
      ];

      return infoList;
    },
    vehicleInfo() {
      const info = this.detailedInfo;

      const infoList = [
        { key: 'id', label: 'ID Vehicle', value: info.vehicle.id },
        { key: 'reg_no', label: 'Registation Number', value: info.vehicle.reg_no },
      ];

      return infoList;
    },
    driverInfo() {
      const info = this.detailedInfo;

      const infoList = [
        { key: 'id', label: 'ID Driver', value: info.driver.id },
        { key: 'name', label: 'Driver Name', value: info.driver.name },
      ];

      return infoList;
    },
    companyInfo() {
      const info = this.detailedInfo;

      const infoList = [
        { key: 'name', label: 'Company Name', value: info.vehicle.company.name },
      ];

      return infoList;
    },
  },
  watch: {
    detailedInfo(data) {
      this.selectedCompany = data.company;
    },
  },
};
</script>
<style lang="sass">
@import "~vue-multiselect/dist/vue-multiselect.min"
</style>



// WEBPACK FOOTER //
// src/views/pages/issues/detail/Detail.vue